module.exports = __webpack_public_path__ + "static/eik-2548238e5ef0e0455fd15be3e2e1a6d3.jpg";